import React,{useEffect,useState, useRef } from 'react';
import UnAssignedScheduleTable from '../components/tables/UnAssignedScheduleTable';
import { GET_UNASSIGNED_SCHEDULE_LIST,GET_DRIVER_LIST,ADD_SCHEDULE_DRIVER,GET_ALL_PAYER } from '../constant'; 
import { Circles } from 'react-loader-spinner';
import axios from 'axios';
import {currentDateFormat} from "../utils";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../messageBox/customSweetAlert';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

export default function UnAssignedScheduleList() {
   const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  //const [loading, setLoading] = useState(false);
  const [scheduleList,setScheduleList] = useState([]);
  const [driverList,setDriverList] = useState([]);
  const [currentDate,setCurrentDate] = useState(new Date());
  const [selectedDriverId, setSelectedDriverId] = useState();
  const [selectedScheduleId, setSelectedScheduleId] = useState();
  const [isReload, setIsReload] = useState(null);
  const { isVisible } = useSelector((state) => state.modal.isVisible);
  const [isModalVisible, setModalVisible] = useState(false);
  const [status, setStatus] = useState('0');
  const [filterValue, setFilterValue] = useState('0');
  const [passengerName, setPassengerName] = useState('');
  const [driverName, setDriverName] = useState('');
  const [filteredScheduleList, setFilteredScheduleList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [pmiNo, setPmiNo] = useState('');
  const [payer, setPayer] = useState('0');
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [payerList, setPayerList] = useState([]);
  const isFirstRender = useRef(false); 
  const [currentDateFilterData,setCurrentDateFilterData] = useState([]);

  const fetchSchedules = async () => {
    dispatch(setLoading(true));
    try {
      const response = await axios.post(GET_UNASSIGNED_SCHEDULE_LIST);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        setScheduleList(response?.data);
        //setFilteredScheduleList(response.data);
        console.log("test render",isFirstRender.current);
        //if (isFirstRender.current) {
          filterByCurrentDate(response?.data); // Apply default filter on first render
          isFirstRender.current = true; // Mark as not the first render
        //}
      }
    } catch (error) {
      console.error('Error fetching schedules:', error);
      dispatch(setLoading(false));
    }
  };
  useEffect(()=>{
    dispatch(setLoading(true));
    
    fetchSchedules();
     const loadUser = async ()=>{
      const response_2 = await axios.get(GET_DRIVER_LIST);
      const response_3 = await axios.get(GET_ALL_PAYER);
      //console.log(response_3.data);
      setPayerList(response_3.data);
      setDriverList(response_2.data)
    }
  loadUser();
},[dispatch]);

 // Filter schedules based on current date on initial render
 const filterByCurrentDate = (data) => {
  const today = new Date();
  const filteredData = data.filter((item) => {
    const scheduleDate = new Date(item.schedule_date);
    return (
      scheduleDate.getFullYear() === today.getFullYear() &&
      scheduleDate.getMonth() === today.getMonth() &&
      scheduleDate.getDate() === today.getDate()
    );
  });
  setCurrentDateFilterData(filteredData)
  //setFilteredScheduleList(filteredData);
};

useEffect(()=>{
const reLoad = async()=>{
  dispatch(setLoading(true));
  const searchPayload = {
      assigned_or_not: filterValue,
      passenger_name: passengerName.trim(),
      pmi_no: pmiNo,
      payer_id: payer,
      from_date: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
      to_date: toDate ? moment(toDate).format("YYYY-MM-DD") : null
    };
  const response = await axios.post(GET_UNASSIGNED_SCHEDULE_LIST,searchPayload);
  //console.log(response.data);
  if(response?.status === 200){
    dispatch(setLoading(false));
    setScheduleList(response?.data);
    //setFilteredScheduleList(response.data);
  }
}
reLoad();
},[isReload]);

// useEffect(() => {
//   if (!isFirstRender.current) {
//     handleSearch(); // Trigger search whenever fromDate or toDate changes
//   }
// }, [fromDate, toDate]);
const driverSaveForm = async()=>{
  try{
    if(selectedDriverId){
      const response = await axios.post(ADD_SCHEDULE_DRIVER,{'scheduleId':selectedScheduleId,'driverId':selectedDriverId})
      if(response.data.status === '200'){
        Swal.fire({
          title: 'Success!',
          text: response.data.message,
          icon: 'success',
          confirmButtonText: 'OK',
        });
         const assignDriver = driverList.find(driver => driver.user_id === selectedDriverId);
     setSelectedDriverId();
        setModalVisible(isVisible);
        
        setCurrentDateFilterData(prev=>{
        return  prev.map(item =>
          item.schedule_id === selectedScheduleId
            ? { ...item, driver: {
              "firstName":assignDriver.first_name,
              "middleName":assignDriver.middle_name,
              "lastName":assignDriver.last_name,
            } }
            : item
        )
        });
        setFilteredScheduleList(prev => {
        return   prev.map(item =>
          item.schedule_id === selectedScheduleId
            ? { ...item, driver: {
              "firstName":assignDriver.first_name,
              "middleName":assignDriver.middle_name,
              "lastName":assignDriver.last_name,
            }  }
            : item
        )
        });
        
      }
    }else{
      Swal.fire({
        title: 'Error!',
        text: "Please select a driver",
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
      
      }catch(error){
        console.error("Error logging in:", error);
      }
}
// {console.log("afterassign ",filteredScheduleList)}


const handlePassengerNameChange = (e) => {
  setPassengerName(e.target.value);
};

const handlePMIChange = (e) => {
  setPmiNo(e.target.value);
};


const handlePayerChange = (e) => {
  setPayer(e.target.value);
};
const setToMidnight = (date,isEndOfDay = false) => {
  const newDate = new Date(date);
  if (isEndOfDay) {
    newDate.setHours(23, 59, 59, 999); // Set to the end of the day
  } else {
    newDate.setHours(0, 0, 0, 0); // Set to the start of the day
  }
  return newDate;
};
const handleSearch = () => {
//   isFirstRender.current = false;
//   const filteredData = scheduleList.filter((item) => {
//    const matchesPassengerName = passengerName === '' || item.passenger.firstName.toLowerCase().includes(passengerName.toLowerCase());
//     const matchesDriverName = driverName === '' || item?.driver?.firstName.toLowerCase().includes(driverName.toLowerCase());
//     const matchesSearchText = searchText === '' || 
//     (item.passenger && item.passenger.firstName.toLowerCase().includes(searchText.toLowerCase()));
//     const matchesPmiNo = pmiNo === '' || (item.passenger?.passenger?.pass_pmi_no && item.passenger?.passenger?.pass_pmi_no.toLowerCase().includes(pmiNo.toLowerCase()));
//     const matchesPayer = payer === '0' || item?.passenger?.passenger?.payers?.id == payer;
//     const matchesFromDate = !fromDate || setToMidnight(new Date(item.schedule_date)) >= setToMidnight(new Date(fromDate));
//     const matchesToDate = !toDate || setToMidnight(new Date(item.schedule_date)) <= setToMidnight(new Date(toDate),true);
// //console.log("matchesFromDate",matchesStatus , matchesPassengerName , matchesDriverName , matchesPmiNo , matchesPayer , matchesFromDate , matchesToDate);
//     return  matchesPassengerName  && matchesPmiNo && matchesPayer && matchesFromDate && matchesToDate;
  
//   });

//   setFilteredScheduleList(filteredData);
const searchPayload = {
    passenger_name: passengerName.trim(),
    pmi_no: pmiNo,
    payer_id: payer,
    from_date: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
    to_date: toDate ? moment(toDate).format("YYYY-MM-DD") : null
  };
  dispatch(setLoading(true)); // optional if using a loading spinner
  
    axios.post(GET_UNASSIGNED_SCHEDULE_LIST, searchPayload)
      .then((response) => {
        if (response?.status === 200) {
          setScheduleList(response?.data); // or setFilteredList
        } else {
          // handle error or empty response
          Swal.fire('Info', response?.data.message || 'No data found', 'info');
        }
      })
      .catch((error) => {
        console.error("Search error", error);
        Swal.fire('Error', 'Something went wrong while searching', 'error');
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
};

const dataSearch=(searchText)=>{
  const filteredData = scheduleList.filter((item) => {
    const matchesSearchText = searchText === '' || 
    (item.passenger && item.passenger.firstName.toLowerCase().includes(searchText.toLowerCase())) ||
    (item.driver && item.driver.firstName.toLowerCase().includes(searchText.toLowerCase()));

    return matchesSearchText;
  });

  setFilteredScheduleList(filteredData);
}
const handleKeyDown = (e) => {
  const value = e.target.value;
  if (value.length >= 8 && e.key !== 'Backspace' && e.key !== 'Delete') {
    e.preventDefault();
  }
};

  let activeTableData = isFirstRender.current ? currentDateFilterData : filteredScheduleList;
let activeSetTableData = isFirstRender.current ? setCurrentDateFilterData : setFilteredScheduleList;
      
return(
    <><section>
    <div className='d-flex justify-content-between form-container'>
          <div>
            <h2 className="fs-5 font-weight-600">Unassigned Schedules</h2>
          </div>
          <div>
            <span >{currentDateFormat(currentDate)}</span>
          </div>
        </div>
    </section>
    <section className='filter-section'>
        <div className='d-flex justify-content-between filter-container'>
        
          <div className='schedule-filter'>
           
            <div className="me-2">
            <label style={{display:"block"}}>Passenger</label>
            <input type="text" 
            name="pass_name" 
            className="form-control"
            value={passengerName} 
            onChange={handlePassengerNameChange}
              />
              
            </div> 
            
            <div className="me-2">
              <label style={{display:"block"}}>PMI No.</label>
              <input type="number" 
              name="pmi_no" 
              className="form-control"
              value={pmiNo}
              onChange={handlePMIChange}
              onKeyDown={handleKeyDown}
                />
              
            </div>
            <div className="me-2">
              <label style={{display:"block"}}>Payer</label>
              <select 
                className="form-select"  
                name="payer" 
                value={payer} 
                onChange={handlePayerChange}
                >
                  <option value="0">All</option>
                  {
                    payerList.map((payer, index) => (
                      <option key={index} value={payer.id}>{payer.payer_name}</option>
                    ))}
              </select>
              
            </div>
            <div className="me-2">
              <label style={{display:"block"}}>From</label>
              <DatePicker
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  dateFormat="MM/dd/yyyy"
                  autoComplete='off'
                  className="datepicker form-control hasDatepicker" 
                  id="from_date" 
                  name="from_date"
                 >
               </DatePicker>
            </div>
            <div className="me-2">
              <label style={{display:"block"}}>To</label>
              <DatePicker
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  dateFormat="MM/dd/yyyy"
                  autoComplete='off'
                  className="datepicker form-control hasDatepicker" 
                  id="to_date" 
                  name="to_date"
                 >
               </DatePicker>
            </div>
            <div>
          <div> 
            <button type='button' 
            style={{background: '#31876f',border:'unset',height: '38px',color: '#fff',padding:'7px'}} 
            onClick={handleSearch}
            >
              SEARCH
              </button>
             </div>  
          </div>
          <div className="me-2 last-input" style={{display:'flex',alignItems:'end',width:'36%',paddingLeft:'20px',display:'none' }}>
                <div>
                      <label style={{display:"block"}}>Search By Passenger/Driver</label>
                      <input type="text" 
                      name="filter_name" 
                      className="form-control"
                      
                      onKeyUp={(e)=>dataSearch(e.target.value)}
                        />
                </div>
              
            </div>
          </div>

        
        </div>
    </section> 
    <section>
      
    <div className="create-schedule-table">
      <div className="table-responsive">
        <UnAssignedScheduleTable  
        tableData={scheduleList} 
        setTableData={setScheduleList} 
        diverList={driverList} 
        setSelectedDriverId={setSelectedDriverId} 
        selectedDriverId={selectedDriverId} 
        onSave={driverSaveForm}
        setSelectedScheduleId ={setSelectedScheduleId}
        setModalVisible={setModalVisible}
        isModalVisible={isModalVisible}
        setIsReload={setIsReload}

        />
      </div>
    </div>
  </section>
  {loading && <Loader />}
  </>
);
}
